/* 🔒 The PDF view's rail as tabs (T1070; decision 1662, amending 1403): the
   tab row above the open panel. The rail's own frame, fold and phone drawer stay
   in the document stylesheet, so the rail folds and opens exactly as before. */

/* The row stands clear of the fold chevron, which the open rail draws at its
   top right (decision 1403). */
.tabs {
  flex: 0 0 auto;
  padding-right: calc(var(--button-height-small) + var(--space-2));
  margin-bottom: var(--space-2);
}

/* 🔒 The open panel is the block the Details view draws, read at the rail's
   width; its own heading stays, so the panel reads the same in both views. */
.panel {
  min-width: 0;
}

/* 🔒 On a rail whose chevron is the one chevron, the Work Order's, a tile handed in folds with the rail and draws none of its own (T2977; decision 6683).
   🔨 Scoped to that rail: unscoped, it hid the History chevron on every document, and a History folded elsewhere opened as a bare heading (review of batch UX3). */
[data-document-rail-fold='rail'] .panel [data-tile-fold] {
  display: none;
}
